import publicMethod from '@/utils/publicMethod';
import { Row, Col } from 'antd';

const PayoutTable = (props: { tableData: any; showPayOut: boolean }) => {
    return (
        <>
            {props.tableData.map((item: any, i) => {
                return (
                    <div className="payout-item" key={`payment-item${i}`}>
                        <Row>
                            <Col span={5}>
                                <div className="item-name">
                                    <div>
                                        {item.taskTitle}
                                        {props.showPayOut && !item.paidToTaskerTime ? (
                                            <div
                                                className="Pending-pay"
                                                style={{ display: 'inline-block', marginLeft: 8 }}
                                            >
                                                Pending
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                </div>
                                <div className="item-content two-line-text">{item.taskDescription ?? '-'}</div>
                            </Col>
                            <Col span={3}></Col>
                            <Col span={7} className="flex-left">
                                <img className="col-icon" src={require('@/assets/images/calendar-t.png')} alt="" />
                                {item.taskWorkTime ?? '-'}
                            </Col>
                            <Col span={4} className="flex-left">
                                <img className="col-icon" src={require('@/assets/images/Amount.png')} alt="" />$
                                {item.actualRemunerationAmount
                                    ? publicMethod.formatPrice(item.actualRemunerationAmount)
                                    : '0.00'}
                            </Col>
                            <Col span={5}>
                                <div className="done-by">
                                    <img src={item?.customer ? item.customer.avatarUrl : '-'} alt="" />
                                    <div>
                                        Posted by <span>{item?.customer ? item.customer.fullName : '-'}</span>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                );
            })}
        </>
    );
};
export default PayoutTable;
